// extracted by mini-css-extract-plugin
export default {"container":"cV_g","partText":"cV_kT","logoText":"cV_kV","awardsContainer":"cV_kW","awardImage":"cV_kX"};